<div
  class="ml-24 mr-12 mb-12 flex items-center justify-between"
  [ngClass]="{ '!mx-12 !justify-center': isCollapsed() }">
  <a
    routerLink="/recruiting/dashboard"
    class="hover:bg-transparent hover:no-underline"
    (click)="isMobile() ? toggleSideNav() : null">
    <saj-logo [width]="120" [hidden]="isCollapsed() || isMobile()"></saj-logo>
    <img
      [hidden]="!isMobile() && !isCollapsed()"
      src="/assets/icon/logo_checked.svg"
      alt=""
      class="w-[20px] h-[20px]" />
  </a>
  <span
    class="material-symbols-rounded p-12 text-[24px] cursor-pointer text-gray-800 rounded-8 hover:bg-purple-100 hover:text-purple-500"
    (click)="toggleSideNav()"
    [hidden]="!isMobile() && isCollapsed()"
    >right_panel_open</span
  >
</div>

<nav
  aria-label="main navigation"
  class="flex flex-col px-12 flex-1 scrollbar overflow-y-auto overflow-x-hidden"
  [ngClass]="{
    'pt-16 border-t border-gray-200 pb-[90px]': isMobile(),
    'px-12': !isMobile(),
  }">
  <span
    class="material-symbols-rounded text-[24px] p-[10px] text-gray-800 rounded-8 cursor-pointer hover:bg-purple-100 hover:text-purple-500 hover:no-underline"
    (click)="toggleSideNav()"
    [hidden]="!isCollapsed()"
    >right_panel_close</span
  >

  <ng-container *ngIf="!isCollapsed(); else collapsedLink">
    <a
      *ngFor="let navMenuItem of navMenu.mainItems"
      class="p-12 ui-md text-gray-900 flex align-center rounded-8 h-[44px] [&>span]:text-gray-900 [&>.icon]:text-gray-800 hover:bg-purple-100 hover:text-purple-500 hover:no-underline"
      [class.mx-12]="isMobile()"
      [routerLink]="navMenuItem.route"
      [routerLinkActive]="'bg-purple-100 [&>*]:!text-purple-500 no-underline'"
      [routerLinkActiveOptions]="linkActiveOptions"
      [attr.data-atm]="'action-link-' + navMenuItem.label.toLowerCase()"
      (click)="navigationHandler(navMenuItem.label)">
      <ng-container
        *ngTemplateOutlet="
          navIcons;
          context: { $implicit: navMenuItem }
        "></ng-container>
      <span class="ml-12">{{ navMenuItem.label }}</span>
    </a>
  </ng-container>
  <ng-template #collapsedLink>
    <a
      *ngFor="let navMenuItem of navMenu.mainItems"
      class="py-12 px-[10px] ui-md text-gray-900 flex align-center rounded-8 h-[44px] [&>span]:text-gray-900 [&>.icon]:text-gray-800 hover:bg-purple-100 hover:no-underline [&>div.w-max]:!absolute [&>div.w-max>saj-tooltip]:!-top-[12px] [&>div.w-max>saj-tooltip]:!left-[42px] [&>div.w-max>saj-tooltip>saj-icon-info-bounded]:!hidden [&>div.w-max>span.border-b-8]:!top-[6px] [&>div.w-max>span.border-b-8]:!left-[30px] [&>div.w-max>span.border-b-8]:!rotate-[270deg]"
      [routerLink]="navMenuItem.route"
      [routerLinkActive]="'bg-purple-100 [&>*]:!text-purple-500 no-underline'"
      [routerLinkActiveOptions]="linkActiveOptions"
      [attr.data-atm]="'action-link-' + navMenuItem.label.toLowerCase()"
      (click)="navigationHandler(navMenuItem.label)">
      <span [sajTooltip]="navMenuItem.label">
        <ng-container
          *ngTemplateOutlet="
            navIcons;
            context: { $implicit: navMenuItem }
          "></ng-container>
      </span>
    </a>
  </ng-template>

  <hr
    class="text-gray-200 my-16"
    *ngIf="
      navMenu.mainItems?.length && accordionPanels.length && !isCollapsed()
    " />

  <saj-accordion *ngIf="accordionPanels.length && !isCollapsed()">
    <saj-accordion-panel
      *ngFor="let panel of accordionPanels; let first = first"
      class="!p-0"
      [ngClass]="{
        'mt-16': !first,
        '[&>div.h-0]:!h-max': isMobile() && !toggledAccordions[panel.header],
      }"
      (closed)="accordionToggled(panel.header)"
      [expanded]="true">
      <saj-accordion-panel-header class="px-12" [ngClass]="{ 'mt-16': !first }"
        ><span class="material-symbols-rounded icon text-[24px]">{{
          panel.header === "Reports" ? "analytics" : "more"
        }}</span
        ><span class="ml-12">{{
          panel.header
        }}</span></saj-accordion-panel-header
      >
      <ul>
        <li *ngFor="let navMenuItem of panel.items">
          <a
            class="py-12 px-12 ui-md flex align-center rounded-8 h-[44px] text-gray-900 hover:bg-purple-100 hover:no-underline"
            [class.mx-12]="isMobile()"
            [routerLink]="navMenuItem.route"
            [routerLinkActive]="'bg-purple-100 text-purple-500 no-underline'"
            [routerLinkActiveOptions]="linkActiveOptions"
            [attr.data-atm]="'action-link-' + navMenuItem.label.toLowerCase()"
            (click)="navigationHandler(navMenuItem.label)">
            <span>{{ navMenuItem.label }}</span>
          </a>
        </li>
      </ul>
    </saj-accordion-panel>
  </saj-accordion>
  @if (accordionPanels.length && isCollapsed()) {
    @for (panel of accordionPanels; track $index) {
      <button
        sajMenuTrigger
        #collapsedMenuTrigger="sajMenuTrigger"
        [triggerFor]="collapsedPanel"
        [menuData]="{ panel }"
        class="h-[44px] text-center"
        (opened)="panel.isOpened = true"
        (closed)="panel.isOpened = false"
        sajButton
        class="!h-[44px] !w-[44px] !p-12 !border-0 !rounded-8 hover:!bg-purple-100 [&>div.w-max]:!absolute [&>div.w-max>saj-tooltip]:!-top-[12px] [&>div.w-max>saj-tooltip]:!left-[42px] [&>div.w-max>saj-tooltip>saj-icon-info-bounded]:!hidden [&>div.w-max>span.border-b-8]:!top-[6px] [&>div.w-max>span.border-b-8]:!left-[30px] [&>div.w-max>span.border-b-8]:!rotate-[270deg]"
        [ngClass]="{
          '!text-purple-500 !bg-purple-100':
            panel.isOpened || isActiveRoute(panel),
          '!text-gray-900 !bg-transparent':
            !panel.isOpened && !isActiveRoute(panel),
        }">
        <span
          [sajTooltip]="
            panel.header === 'Reports' ? 'Reports' : 'Organization'
          ">
          <span class="material-symbols-rounded icon text-[24px]">{{
            panel.header === "Reports" ? "analytics" : "more"
          }}</span>
        </span>
        <saj-menu #collapsedPanel>
          <ng-template sajMenuContent let-panel="panel">
            <a
              *ngFor="let navMenuItem of panel.items"
              sajMenuItem
              class="py-12 px-12 ui-md flex align-center h-[44px] text-gray-900 hover:bg-purple-100 hover:no-underline"
              [routerLink]="navMenuItem.route"
              [routerLinkActive]="'bg-purple-100 text-purple-500 no-underline'"
              [routerLinkActiveOptions]="linkActiveOptions"
              [attr.data-atm]="'action-link-' + navMenuItem.label.toLowerCase()"
              (click)="
                navigationHandler(navMenuItem.label);
                collapsedMenuTrigger.close()
              ">
              <span>{{ navMenuItem.label }}</span>
            </a>
          </ng-template>
        </saj-menu>
      </button>
    }
  }
</nav>

<div class="px-12" [ngClass]="{ 'pt-12 border-t border-gray-200': isMobile() }">
  <button
    sajButton
    sajMenuTrigger
    *ngIf="user && account"
    [triggerFor]="isMobile() ? accountInfoMenuMobile : accountInfoTemplate"
    class="w-full"
    #accountInfoMenuTrigger="sajMenuTrigger"
    (opened)="accountInfoMenuOpened = true"
    data-snagtag="menu-button"
    class="!p-0 !border-none !bg-transparent w-full">
    <account-info
      [isCollapsed]="isCollapsed()"
      [user]="user"
      [account]="account"></account-info>
  </button>
  <saj-menu
    #accountInfoTemplate
    #accountInfoMenu
    [positionX]="!isCollapsed() ? 'right' : 'left'">
    <a
      sajMenuItem
      routerLink="/profile"
      [attr.data-atm]="'action-link-profile'"
      class="hover:no-underline"
      (click)="navigationHandler('profile')">
      <saj-icon-account-bounded
        class="w-[20px] mr-4 text-gray-800"></saj-icon-account-bounded>
      <span class="text-gray-900">View Profile</span>
    </a>

    <div class="relative">
      <a
        sajMenuItem
        sajMenuTrigger
        [triggerFor]="settingsMenu"
        class="hover:no-underline"
        [ngClass]="{ 'bg-purple-100': settingsMenuOpened }">
        <saj-icon-gear class="w-[20px] mr-4 text-gray-800"></saj-icon-gear>
        <span class="text-gray-900">Account Settings</span>
        <saj-icon-chevron-right
          class="w-[20px] text-gray-800"></saj-icon-chevron-right>
      </a>
    </div>

    <a
      *ngIf="showSwitchAccounts"
      sajMenuItem
      sajMenuTrigger
      [triggerFor]="switchAccountMenu"
      class="hover:no-underline"
      [ngClass]="{ 'bg-purple-100': switchAccountMenuOpened }">
      <saj-icon-gear class="w-[20px] mr-4 text-gray-800"></saj-icon-gear>
      <span class="text-gray-900">Switch Accounts</span>
    </a>

    <a
      sajMenuItem
      routerLink="/auth/logout"
      class="hover:no-underline"
      [attr.data-atm]="'action-link-log out'"
      (click)="navigationHandler('sign out')">
      <span class="material-symbols-rounded text-[24px]">logout</span>
      <span class="text-gray-900">Sign Out</span>
    </a>
  </saj-menu>

  <saj-menu #accountInfoMenuMobile>
    <ng-template sajMenuContent>
      <div class="max-h-[calc(100svh_-_68px)] overflow-y-auto">
        <div class="sticky top-0 bg-white">
          <div class="body-strong-sm text-black text-center mb-16">
            Account and settings
          </div>

          <button
            sajMenuTrigger
            [triggerFor]="switchAccountMenu"
            *ngIf="showSwitchAccounts"
            (opened)="accountInfoMenuTrigger.close()"
            sajButton
            class="mb-8 !h-[52px] border !border-gray-300 !rounded-4 !px-16 !py-8 !flex !items-center cursor-pointer !bg-white w-full">
            <span
              class="text-gray-700 ui-md flex-1 truncate max-w-[calc(100%_-_32px)] whitespace-nowrap text-left"
              >{{ account.name }} ({{ account.id }})</span
            >
            <span
              class="material-symbols-rounded text-[24px] ml-8 text-gray-700"
              >expand_all</span
            >
          </button>

          @if (user) {
            <div
              class="border-b border-gray-200 mb-16 pb-16 ui-sm text-gray-700">
              Logged in as ({{ user.emailAddress }})
            </div>
          }
        </div>

        <div class="mb-12 body-strong-sm text-black">User settings</div>

        <a
          sajMenuItem
          routerLink="/profile"
          [routerLinkActive]="
            'bg-purple-100 [&>*]:!text-purple-500 no-underline'
          "
          [attr.data-atm]="'action-link-profile'"
          class="hover:no-underline !mx-0"
          (click)="navigationHandler('profile')">
          <span class="material-symbols-rounded text-[24px] pr-4"
            >manage_accounts</span
          >
          <span class="text-gray-900">Profile settings</span>
        </a>

        <div class="my-12 body-strong-sm text-black">Account settings</div>

        <a
          sajMenuItem
          [routerLink]="navMenuItem.route"
          class="hover:no-underline !mx-0"
          *ngFor="let navMenuItem of navMenu.settingsItems"
          [attr.data-atm]="'action-link-' + navMenuItem.label.toLowerCase()"
          [routerLinkActive]="
            'bg-purple-100 [&>*]:!text-purple-500 no-underline'
          "
          (click)="navigationHandler(navMenuItem.label)">
          <ng-container
            *ngTemplateOutlet="
              navIcons;
              context: { $implicit: navMenuItem }
            "></ng-container>
          <span class="text-gray-900">{{ navMenuItem.label }}</span>
        </a>

        <div class="my-12 body-strong-sm text-black">Feedback and support</div>
        <button
          class="mx-0"
          sajMenuItem
          (click)="openGuide(); accountInfoMenuTrigger.close()">
          <saj-icon-share
            class="w-[28px] h-[24px] text-gray-800 pr-4"></saj-icon-share>
          Employer guide
        </button>
        <button
          class="mx-0"
          sajMenuItem
          (click)="openShareFeedbackModal(); accountInfoMenuTrigger.close()">
          <span class="material-symbols-rounded text-[24px] pr-4">chat</span>
          Share feedback
        </button>
        <button
          class="mx-0"
          sajMenuItem
          (click)="openContactSupportModal(); accountInfoMenuTrigger.close()">
          <span class="material-symbols-rounded text-[24px] pr-4">support</span>
          Contact support
        </button>

        <a
          sajMenuItem
          routerLink="/auth/logout"
          class="hover:no-underline !mx-0 pt-24 border-t border-gray-200 mt-12"
          [attr.data-atm]="'action-link-log out'"
          (click)="navigationHandler('sign out')">
          <span class="material-symbols-rounded text-[24px] pr-4">logout</span>
          <span class="text-gray-900">Sign Out</span>
        </a>
      </div>
    </ng-template>
  </saj-menu>
</div>

<ng-template #navIcons let-navMenuItem>
  <ng-container [ngSwitch]="navMenuItem.id">
    <span
      *ngSwitchCase="MenuIds.Dashboard"
      class="material-symbols-rounded icon text-[24px]"
      >dashboard</span
    >
    <span
      *ngSwitchCase="MenuIds.Posting"
      class="material-symbols-rounded icon text-[24px]"
      >work</span
    >
    <span
      *ngSwitchCase="MenuIds.Promote"
      class="material-symbols-rounded icon text-[24px]"
      >campaign</span
    >
    <span
      *ngSwitchCase="MenuIds.FeaturedAd"
      class="material-symbols-rounded icon text-[24px]"
      >new_releases</span
    >
    <span
      *ngSwitchCase="MenuIds.Candidate"
      class="material-symbols-rounded icon text-[24px]"
      >group_add</span
    >
    <span
      *ngSwitchCase="MenuIds.InterviewScheduled"
      class="material-symbols-rounded icon text-[24px]"
      >event</span
    >
    <span
      *ngSwitchCase="MenuIds.Billing"
      class="material-symbols-rounded icon text-[24px]"
      >credit_card</span
    >
    <span
      *ngSwitchCase="MenuIds.Users"
      class="material-symbols-rounded icon text-[24px]"
      >groups_2</span
    >
    <span
      *ngSwitchCase="MenuIds.Feeds"
      class="material-symbols-rounded icon text-[24px]"
      >flowsheet</span
    >
    <span
      *ngSwitchCase="MenuIds.Audit"
      class="material-symbols-rounded icon text-[24px]"
      >quick_reference_all</span
    >
    <span
      *ngSwitchCase="MenuIds.Roles"
      class="material-symbols-rounded icon text-[24px]"
      >shield_person</span
    >
    <span
      *ngSwitchCase="MenuIds.CompanyInfo"
      class="material-symbols-rounded icon text-[24px]"
      >help_clinic</span
    >
  </ng-container>
</ng-template>

<saj-menu #switchAccountMenu>
  <ng-template sajMenuContent>
    <div
      class="tablet:hidden hidden body-strong-sm text-black text-center mb-16">
      Switch account
    </div>

    <a
      sajMenuItem
      routerLink="/recruiting/dashboard"
      class="hover:no-underline !mx-0 bg-purple-100"
      (click)="navigationHandler()">
      <saj-icon-check class="w-[20px] text-purple-500"></saj-icon-check>
      <span class="text-purple-500">{{ account?.name }}</span>
    </a>
    <a
      sajMenuItem
      *ngFor="let userAccount of userAccounts"
      (click)="switchAccount(userAccount.permissionId)"
      class="hover:no-underline !mx-0"
      data-atm="account-menu-option">
      <span class="text-gray-900">{{ userAccount.accountName }}</span>
    </a>
  </ng-template>
</saj-menu>

<saj-menu
  #settingsMenu
  class="absolute bg-white flex flex-col max-h-[480px] px-menudefaultx py-menudefaulty rounded-8 opacity-0 scale-0 shadow-200 transition-all w-max z-50"
  [ngClass]="{ '!opacity-100 !scale-100': settingsMenuOpened }">
  <ng-template sajMenuContent>
    @for (navMenuItem of navMenu.settingsItems; track $index) {
      <a
        sajMenuItem
        [routerLink]="navMenuItem.route"
        class="hover:no-underline"
        [attr.data-atm]="'action-link-' + navMenuItem.label.toLowerCase()"
        (click)="navigationHandler(navMenuItem.label)">
        <ng-container
          *ngTemplateOutlet="
            navIcons;
            context: { $implicit: navMenuItem }
          "></ng-container>

        <span class="text-gray-900">{{ navMenuItem.label }}</span>
      </a>
    }
  </ng-template>
</saj-menu>
